import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PlanGateProps {
  children: React.ReactNode;
  requiredPlan: 'free' | 'basic' | 'premium';
  redirectTo?: string;
}

const PLAN_HIERARCHY: Record<'free' | 'basic' | 'premium', number> = {
  free: 0,
  basic: 1,
  premium: 2
};

export const PlanGate: React.FC<PlanGateProps> = ({ 
  children, 
  requiredPlan, 
  redirectTo = '/pricing' 
}) => {
  const { user, isLoggedIn, isAuthLoading } = useAuth();

  if (isAuthLoading) {
    return (
      <div className="min-h-[40vh] flex items-center justify-center">
        <div className="w-6 h-6 border-2 border-gold-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // If not logged in, redirect to login
  if (!isLoggedIn) {
    return <Navigate to="/auth/login" replace />;
  }

  // Check if user's plan meets the requirement
  const userPlanLevel = PLAN_HIERARCHY[user?.plan || 'free'];
  const requiredPlanLevel = PLAN_HIERARCHY[requiredPlan];

  if (userPlanLevel < requiredPlanLevel) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
